import React, { useEffect, useState } from "react";
import ChatbotImage from "./../assets/chatbot.png";
import { Link } from "react-router";

const ChatBot = () => {
  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);
  return (
    <Link
      to="/smile-bot"
      className="align-items-center justify-content-end text-decoration-none"
      style={{
        // position: "fixed",
        // top: "10px",
        // right: screenWidth <= 768 ? "50px" : "",
        zIndex: "100",
        // transform: screenWidth > 768 ? "translateX(680px)" : "",
        opacity: "1",
        cursor: "pointer",
      }}
    >
      <div className="col-auto px-2 mx-2">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            width: "45px",
            height: "45px",
            backgroundColor: "rgb(12, 192, 223)",
            borderRadius: "50%",
            // opacity: "0.8",
          }}
        >
          <div className="d-flex flex-column align-items-center justify-content-center">
            <img
              className=""
              src={ChatbotImage}
              alt=""
              style={{
                width: "35px",
                maxWidth: "100%",
              }}
            />

            {/* <div
              className=""
              style={{
                fontSize: "8px",
                color: "#000000",
              }}
            >
              Chatbot
            </div> */}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ChatBot;
